import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ChakraProvider, Flex } from '@chakra-ui/react'
import Header from './components/Header'
import Nav from './components/Nav'
import Footer from './components/Footer'
import Uses from './components/Uses'
import theme from './theme'

const App = () => {
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <Flex direction="column" minH="100vh">
          <Nav />
          <Routes>
            <Route path="/" element={<Header />} />
            <Route path="/uses" element={<Uses />} />
          </Routes>
          <Footer />
        </Flex>
      </Router>
    </ChakraProvider>
  )
}

export default App
